
class Animations {

    fadeout(target, interval = 400) {
        const targetEl = target[0];

        const fadeEffect = setInterval(function () {
            if (!targetEl.style.opacity) {
                targetEl.style.opacity = 1;
            }
            if (targetEl.style.opacity > 0) {
                targetEl.style.opacity -= 0.1;
            } else {
                clearInterval(fadeEffect);
                target.hide();
            }
        }, interval / 10);
    }

    fadein(target, interval = 400) {
        const targetEl = target[0];
    
        targetEl.style.opacity = 0;
        target.show();
    
        const fadeEffect = setInterval(function () {
            let currentOpacity = parseFloat(targetEl.style.opacity);
            
            if (currentOpacity < 1) {
                targetEl.style.opacity = (currentOpacity + 0.1).toString();
            } else {
                clearInterval(fadeEffect);
            }
        }, interval / 10);
    }

}